import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import { Merchant } from "../@types";

function useMerchantDetails(
  merchantId: string,
  options?: QueryObserverOptions<APIResponse<Merchant>, APIError>
) {
  const {
    data: merchant,
    isError,
    error,
    isLoading,
  } = useQuery<APIResponse<Merchant>, APIError>(
    "merchant-details-" + merchantId,
    () =>
      get(API_URL + "/commerce/merchants/" + merchantId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    merchant,
    isError,
    error,
    isLoading,
  };
}

export default useMerchantDetails;
